import { REPEAT } from "../constants/action_types.js";

const repeat_handler = (repeat = false, action) =>
{
  switch (action.type)
  {
    case REPEAT:
      return !repeat;
    default:
      return repeat;
  }
}

export default repeat_handler;